
// import React, { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import CircularProgress from "@mui/material/CircularProgress";
// import MDBox from "components/MDBox";
// import SimpleStatisticsCard from "examples/Cards/StatisticsCards/SimpleStatisticsCard";
// import platformUtils from "../platformUtils";
// import dayjs from "dayjs";

// // Import split metric components
// import AudienceKeyMetrics from "./AudienceKeyMetrics";
// import ContentKeyMetrics from "./ContentKeyMetrics";
// import EngagementKeyMetrics from "./EngagementKeyMetrics";
// // import SentimentKeyMetrics from "./SentimentKeyMetrics"; // Not used here as it's empty

// // -------------------------------------------------------
// // Helper Functions (Kept in main file as they are shared)
// // -------------------------------------------------------
// export const getFollowerValue = (item, metricKey, predictedMetricKey) => {
// if (!item) return { value: null, isPredicted: false };
// const actual = item[metricKey];
// const predicted = item[predictedMetricKey];
// if (actual != null && actual > 0) return { value: actual, isPredicted: false };
// if (predicted != null && predicted > 0) return { value: predicted, isPredicted: true };
// if (actual != null) return { value: actual, isPredicted: false };
// if (predicted != null) return { value: predicted, isPredicted: true };
// return { value: null, isPredicted: false };
// };

// export const formatNumber = (n) => {
// if (n === null || n === undefined) return "-";
// // Ensure n is a number before calling Math.abs
// const num = Number(n);
// if (isNaN(num)) return "-";

// if (Math.abs(num) >= 1_000_000) return (num / 1_000_000).toFixed(2) + "M";
// if (Math.abs(num) >= 1_000) return (num / 1_000).toFixed(2) + "K";
// return num.toLocaleString();
// };

// export const getTooltipData = (currentValue, previousValue, currentData, previousData) => {
// // Ensure data arrays are present before accessing elements
// const currentStart = currentData?.length > 0 ? dayjs(currentData[0].date).format("MMM DD, YYYY") : 'N/A';
// const currentEnd = currentData?.length > 0 ? dayjs(currentData.at(-1).date).format("MMM DD, YYYY") : 'N/A';
// const previousStart = previousData?.length > 0 ? dayjs(previousData[0].date).format("MMM DD, YYYY") : 'N/A';
// const previousEnd = previousData?.length > 0 ? dayjs(previousData.at(-1).date).format("MMM DD, YYYY") : 'N/A';

// return {
// currentValue: currentValue,
// previousValue: previousValue,
// currentRange: `${currentStart} - ${currentEnd}`,
// previousRange: `${previousStart} - ${previousEnd}`,
// };
// };

// // -------------------------------------------------------
// // Main Component
// // -------------------------------------------------------
// export default function KeyMetrics({
// profile,
// datasets = [],
// previousdatasets = [],
// adjustedcurrentdatasets = [],
// adjustedpreviousdatasets = [],
// selectedCategories = [],
// }) {
// const { platform } = profile;
// const platformLogic = platformUtils[platform];
// if (!platformLogic) return null;

// console.log("Profile Data in Key Metrics : ", profile);

// const isYouTube = platform === "YouTube";
// const metricKey = isYouTube ? "subscribers" : "followers";
// const predictedMetricKey = isYouTube ? "predicted_subscribers" : "predicted_followers";
// const metricName = isYouTube ? "Subscribers" : "Followers";

// // -------------------------------------------------------
// // Data Preparation & Sorting
// // -------------------------------------------------------
// const currentProfile = datasets.find((p) => p.profileId === profile.profileId);
// const previousProfile = previousdatasets.find((p) => p.profileId === profile.profileId);
// const adjustedCurrent = adjustedcurrentdatasets.find(
// (p) => p.profileId === profile.profileId
// );
// const adjustedPrevious = adjustedpreviousdatasets.find(
// (p) => p.profileId === profile.profileId
// );

// const validData = Array.isArray(currentProfile?.data) ? [...currentProfile.data] : [];
// const previousValidData = Array.isArray(previousProfile?.data)
// ? [...previousProfile.data]
// : [];
// const adjustedCurrentData = Array.isArray(adjustedCurrent?.data)
// ? [...adjustedCurrent.data]
// : [];
// const adjustedPreviousData = Array.isArray(adjustedPrevious?.data)
// ? [...adjustedPrevious.data]
// : [];

// validData.sort((a, b) => new Date(a.date) - new Date(b.date));
// previousValidData.sort((a, b) => new Date(a.date) - new Date(b.date));
// adjustedCurrentData.sort((a, b) => new Date(a.date) - new Date(b.date));
// adjustedPreviousData.sort((a, b) => new Date(a.date) - new Date(b.date));

// const loading =
// !validData.length ||
// !previousValidData.length ||
// !adjustedCurrentData.length ||
// !adjustedPreviousData.length;

// // FIX: Add a default function assignment to prevent TypeError if calculateTotalViews is missing
// const { 
//  calculateTotalPosts, 
//  calculateTotalReactions, 
//  calculateTotalViews = () => 0,
//  calculateTotalImpressions = () => 0,
//  calculateTotalReach = () => 0,
//  calculateTotalPostImpressions = () => 0,
//  calculateTotalPostReach = () => 0,
//  // ⭐️ ADD calculateTotalPostClicks HERE
//  calculateTotalPostClicks = () => 0,
// } = platformLogic;


// // Calculate span days once
// const currSpanDays =
// validData.length > 1
// ? dayjs(validData.at(-1).date).diff(dayjs(validData[0].date), "day") + 1
// : 1;

// const prevSpanDays =
// previousValidData.length > 1
// ? dayjs(previousValidData.at(-1).date).diff(dayjs(previousValidData[0].date), "day") + 1
// : 1;


// // CALCULATE IMPRESSIONS AND REACH (for Audience/Page)
// const totalImpressions = calculateTotalImpressions(validData) || 0;
// const prevTotalImpressions = calculateTotalImpressions(previousValidData) || 0;

// const totalReach = calculateTotalReach(validData) || 0;
// const prevTotalReach = calculateTotalReach(previousValidData) || 0;

// // CALCULATE POST IMPRESSIONS AND REACH (for Content)
// const totalPostImpressions = calculateTotalPostImpressions(validData) || 0;
// const prevTotalPostImpressions = calculateTotalPostImpressions(previousValidData) || 0;

// const totalPostReach = calculateTotalPostReach(validData) || 0;
// const prevTotalPostReach = calculateTotalPostReach(previousValidData) || 0;

// // ⭐️ CALCULATE POST CLICKS (for Engagement)
// const totalPostClicks = calculateTotalPostClicks(validData) || 0;
// const prevTotalPostClicks = calculateTotalPostClicks(previousValidData) || 0;


// // -------------------------------------------------------
// // Consolidate Card Generation
// // -------------------------------------------------------
// let cards = [];

// // 🟣 Audience Metrics (Unchanged logic)
// if (selectedCategories.includes("Audience") || selectedCategories.length === 0) {
//  cards.push(
//  ...AudienceKeyMetrics({
//   validData,
//   previousValidData,
//   adjustedCurrentData,
//   adjustedPreviousData,
//   metricKey,
//   predictedMetricKey,
//   metricName,
//   currSpanDays,
//   prevSpanDays,
//   totalImpressions, 
//   prevTotalImpressions,
//   totalReach, 
//   prevTotalReach,
//  })
//  );
// }

// // 🟡 Content Metrics (Unchanged logic)
// if (selectedCategories.includes("Content")) {
//  cards.push(
//  ...ContentKeyMetrics({
//   validData,
//   previousValidData,
//   totalPosts: calculateTotalPosts(validData),
//   prevTotalPosts: calculateTotalPosts(previousValidData),
//   totalReactions: calculateTotalReactions(validData),
//   prevTotalReactions: calculateTotalReactions(previousValidData),
//   totalViews: calculateTotalViews(validData) || 0,
//   prevTotalViews: calculateTotalViews(previousValidData) || 0,
//   currSpanDays,
//   prevSpanDays,
//   totalPostImpressions,
//   prevTotalPostImpressions,
//   totalPostReach,
//   prevTotalPostReach,
//  })
//  );
// }

// // 🔴 Engagement Metrics 
// if (selectedCategories.includes("Engagement")) {
//  // Need totalFollowers and totalReactions for Engagement Metrics
//  const totalFollowers = getFollowerValue(validData.at(-1), metricKey, predictedMetricKey).value ?? 0;
//  const prevFollowers = getFollowerValue(previousValidData.at(-1), metricKey, predictedMetricKey).value ?? 0;
//  const totalReactions = calculateTotalReactions(validData);
//  const prevTotalReactions = calculateTotalReactions(previousValidData);

//  cards.push(
//  ...EngagementKeyMetrics({
//   validData,
//   previousValidData,
//   totalFollowers,
//   prevFollowers,
//   totalReactions,
//   prevTotalReactions,
//   // ⭐️ PASS NEW POST CLICKS TO ENGAGEMENT METRICS
//   totalPostClicks,
//   prevTotalPostClicks,
//  })
//  );
// }


// // -------------------------------------------------------
// // Animation Logic
// // -------------------------------------------------------
// const [prevTitles, setPrevTitles] = useState([]);
// useEffect(() => {
// setPrevTitles(cards.map((c) => c.title));
// }, [cards.map((c) => c.title).join(",")]);

// // -------------------------------------------------------
// // Render
// // -------------------------------------------------------
// return (
//  <MDBox
//  display="flex"
//  flexWrap="wrap"
//  justifyContent="center"
//  alignItems="stretch"
//  gap={3}
//  px={2}
//  mt={1}
//  >
//  <AnimatePresence>
//   {cards.map((card, index) => {
//   // Use the common delay logic from the original file
//   const isNew = !prevTitles.includes(card.title);
//   const delay = isNew ? 0.25 + index * 0.03 : 0;

//   return (
//    <motion.div
//    key={card.title}
//    layout
//    initial={{ opacity: 0, scale: 0.85 }}
//    animate={{ opacity: 1, scale: 1 }}
//    exit={{ opacity: 0, scale: 0.85 }}
//    transition={{
//     layout: { duration: 0.75, ease: [0.25, 0.8, 0.25, 1] },
//     duration: 0.4,
//     ease: [0.25, 0.8, 0.25, 1],
//     delay,
//    }}
//    style={{
//     flex: "1 1 calc(20% - 16px)",
//     minWidth: 250,
//     maxWidth: 250,
//    }}
//    >
//    <SimpleStatisticsCard {...card} />
//    </motion.div>
//   );
//   })}
//  </AnimatePresence>
//  </MDBox>
// );
// }

// // ###################################################

import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import SimpleStatisticsCard from "examples/Cards/StatisticsCards/SimpleStatisticsCard";
import platformUtils from "../platformUtils";
import dayjs from "dayjs";

// Import split metric components
import AudienceKeyMetrics from "./AudienceKeyMetrics";
import DemographicKeyMetrics from "./DemographicKeyMetrics"; // ✅ Added Import
import ContentKeyMetrics from "./ContentKeyMetrics";
import EngagementKeyMetrics from "./EngagementKeyMetrics";

// -------------------------------------------------------
// Helper Functions (Kept in main file as they are shared)
// -------------------------------------------------------
export const getFollowerValue = (item, metricKey, predictedMetricKey) => {
  if (!item) return { value: null, isPredicted: false };
  const actual = item[metricKey];
  const predicted = item[predictedMetricKey];
  if (actual != null && actual > 0) return { value: actual, isPredicted: false };
  if (predicted != null && predicted > 0) return { value: predicted, isPredicted: true };
  if (actual != null) return { value: actual, isPredicted: false };
  if (predicted != null) return { value: predicted, isPredicted: true };
  return { value: null, isPredicted: false };
};

export const formatNumber = (n) => {
  if (n === null || n === undefined) return "-";
  const num = Number(n);
  if (isNaN(num)) return "-";

  if (Math.abs(num) >= 1_000_000) return (num / 1_000_000).toFixed(2) + "M";
  if (Math.abs(num) >= 1_000) return (num / 1_000).toFixed(2) + "K";
  return num.toLocaleString();
};

export const getTooltipData = (currentValue, previousValue, currentData, previousData) => {
  const currentStart = currentData?.length > 0 ? dayjs(currentData[0].date).format("MMM DD, YYYY") : 'N/A';
  const currentEnd = currentData?.length > 0 ? dayjs(currentData.at(-1).date).format("MMM DD, YYYY") : 'N/A';
  const previousStart = previousData?.length > 0 ? dayjs(previousData[0].date).format("MMM DD, YYYY") : 'N/A';
  const previousEnd = previousData?.length > 0 ? dayjs(previousData.at(-1).date).format("MMM DD, YYYY") : 'N/A';

  return {
    currentValue: currentValue,
    previousValue: previousValue,
    currentRange: `${currentStart} - ${currentEnd}`,
    previousRange: `${previousStart} - ${previousEnd}`,
  };
};

// -------------------------------------------------------
// Main Component
// -------------------------------------------------------
export default function KeyMetrics({
  profile,
  datasets = [],
  previousdatasets = [],
  adjustedcurrentdatasets = [],
  adjustedpreviousdatasets = [],
  selectedCategories = [],

  // ⭐ ONLY NEW PROP ADDED
  hideKeyMetrics = false,
}) {
  const { platform } = profile;
  const platformLogic = platformUtils[platform];
  if (!platformLogic) return null;


  const isYouTube = platform === "YouTube";
  const metricKey = isYouTube ? "subscribers" : "followers";
  const predictedMetricKey = isYouTube ? "predicted_subscribers" : "predicted_followers";
  const metricName = isYouTube ? "Subscribers" : "Followers";

  // -------------------------------------------------------
  // Data Preparation & Sorting
  // -------------------------------------------------------
  const currentProfile = datasets.find((p) => p.profileId === profile.profileId);
  const previousProfile = previousdatasets.find((p) => p.profileId === profile.profileId);
  const adjustedCurrent = adjustedcurrentdatasets.find((p) => p.profileId === profile.profileId);
  const adjustedPrevious = adjustedpreviousdatasets.find((p) => p.profileId === profile.profileId);

  const validData = Array.isArray(currentProfile?.data) ? [...currentProfile.data] : [];
  const previousValidData = Array.isArray(previousProfile?.data) ? [...previousProfile.data] : [];
  const adjustedCurrentData = Array.isArray(adjustedCurrent?.data) ? [...adjustedCurrent.data] : [];
  const adjustedPreviousData = Array.isArray(adjustedPrevious?.data) ? [...adjustedPrevious.data] : [];

  validData.sort((a, b) => new Date(a.date) - new Date(b.date));
  previousValidData.sort((a, b) => new Date(a.date) - new Date(b.date));
  adjustedCurrentData.sort((a, b) => new Date(a.date) - new Date(b.date));
  adjustedPreviousData.sort((a, b) => new Date(a.date) - new Date(b.date));

  const loading =
    !validData.length ||
    !previousValidData.length ||
    !adjustedCurrentData.length ||
    !adjustedPreviousData.length;

  const {
    calculateTotalPosts,
    calculateTotalReactions,
    calculateTotalViews = () => 0,
    calculateTotalImpressions = () => 0,
    calculateTotalReach = () => 0,
    calculateTotalPostImpressions = () => 0,
    calculateTotalPostReach = () => 0,
    calculateTotalPostClicks = () => 0,
  } = platformLogic;

  // Days range
  const currSpanDays =
    validData.length > 1
      ? dayjs(validData.at(-1).date).diff(dayjs(validData[0].date), "day") + 1
      : 1;

  const prevSpanDays =
    previousValidData.length > 1
      ? dayjs(previousValidData.at(-1).date).diff(dayjs(previousValidData[0].date), "day") + 1
      : 1;

  // Calculations
  const totalImpressions = calculateTotalImpressions(validData) || 0;
  const prevTotalImpressions = calculateTotalImpressions(previousValidData) || 0;

  const totalReach = calculateTotalReach(validData) || 0;
  const prevTotalReach = calculateTotalReach(previousValidData) || 0;

  const totalPostImpressions = calculateTotalPostImpressions(validData) || 0;
  const prevTotalPostImpressions = calculateTotalPostImpressions(previousValidData) || 0;

  const totalPostReach = calculateTotalPostReach(validData) || 0;
  const prevTotalPostReach = calculateTotalPostReach(previousValidData) || 0;

  const totalPostClicks = calculateTotalPostClicks(validData) || 0;
  const prevTotalPostClicks = calculateTotalPostClicks(previousValidData) || 0;

  // -------------------------------------------------------
  // Consolidate Card Generation
  // -------------------------------------------------------
  let cards = [];

  if (selectedCategories.includes("Audience") || selectedCategories.length === 0) {
    cards.push(
      ...AudienceKeyMetrics({
        validData,
        previousValidData,
        adjustedCurrentData,
        adjustedPreviousData,
        metricKey,
        predictedMetricKey,
        metricName,
        currSpanDays,
        prevSpanDays,
        totalImpressions,
        prevTotalImpressions,
        totalReach,
        prevTotalReach,
      })
    );

  }

  // ⭐ NEW: Add Demographic Metrics ONLY if Demographics is selected (or "All")
  if (selectedCategories.includes("Demographics") || selectedCategories.length === 0) {
    cards.push(...DemographicKeyMetrics({ profile }));
  }

  if (selectedCategories.includes("Content")) {
    cards.push(
      ...ContentKeyMetrics({
        validData,
        previousValidData,
        totalPosts: calculateTotalPosts(validData),
        prevTotalPosts: calculateTotalPosts(previousValidData),
        totalReactions: calculateTotalReactions(validData),
        prevTotalReactions: calculateTotalReactions(previousValidData),
        totalViews: calculateTotalViews(validData) || 0,
        prevTotalViews: calculateTotalViews(previousValidData) || 0,
        currSpanDays,
        prevSpanDays,
        totalPostImpressions,
        prevTotalPostImpressions,
        totalPostReach,
        prevTotalPostReach,
      })
    );
  }

  if (selectedCategories.includes("Engagement")) {
    const totalFollowers =
      getFollowerValue(validData.at(-1), metricKey, predictedMetricKey).value ?? 0;
    const prevFollowers =
      getFollowerValue(previousValidData.at(-1), metricKey, predictedMetricKey).value ?? 0;

    const totalReactions = calculateTotalReactions(validData);
    const prevTotalReactions = calculateTotalReactions(previousValidData);

    cards.push(
      ...EngagementKeyMetrics({
        validData,
        previousValidData,
        totalFollowers,
        prevFollowers,
        totalReactions,
        prevTotalReactions,
        totalPostClicks,
        prevTotalPostClicks,
      })
    );
  }

  // -------------------------------------------------------
  // ⭐ ONLY NEW THING ADDED (do not touch anything else)
  // -------------------------------------------------------
  if (hideKeyMetrics) {
    const restricted = new Set([
      "Total Views",
      "Total Reach",
      "Total Post Views",
      "Total Post Reach",
      "Total Post Clicks",
    ]);

    cards = cards.filter((c) => !restricted.has(c.title));
  }

  // -------------------------------------------------------
  // Animation Logic
  // -------------------------------------------------------
  const [prevTitles, setPrevTitles] = useState([]);
  useEffect(() => {
    setPrevTitles(cards.map((c) => c.title));
  }, [cards.map((c) => c.title).join(",")]);

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------
  return (
    <MDBox
      display="flex"
      flexWrap="wrap"
      justifyContent="center"
      alignItems="stretch"
      gap={3}
      px={2}
      mt={1}
    >
      <AnimatePresence>
        {cards.map((card, index) => {
          const isNew = !prevTitles.includes(card.title);
          const delay = isNew ? 0.25 + index * 0.03 : 0;

          return (
            <motion.div
              key={card.title}
              layout
              initial={{ opacity: 0, scale: 0.85 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.85 }}
              transition={{
                layout: { duration: 0.75, ease: [0.25, 0.8, 0.25, 1] },
                duration: 0.4,
                ease: [0.25, 0.8, 0.25, 1],
                delay,
              }}
              style={{
                flex: "1 1 calc(20% - 16px)",
                minWidth: 250,
                maxWidth: 250,
              }}
            >
              <SimpleStatisticsCard {...card} />
            </motion.div>
          );
        })}
      </AnimatePresence>
    </MDBox>
  );
}
